import { writable } from 'svelte/store';

// 1. Define Supported Countries
export const SUPPORTED_COUNTRIES = [
  { code: 'HK', name: 'Hong Kong', flag: '🇭🇰', currency: 'HKD' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', currency: 'GBP' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', currency: 'JPY' }
];

const DEFAULT_COUNTRY_CODE = 'HK';
const STORAGE_KEY = 'selected_country_code';

// 2. Initialize Logic
// Try to get the value from browser storage, otherwise use default.
const getInitialCountry = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  // Verify the stored code is still valid in our list
  if (stored && SUPPORTED_COUNTRIES.some(c => c.code === stored)) {
    return stored;
  }
  return DEFAULT_COUNTRY_CODE;
};

// 3. Create the Store
export const selectedCountry = writable(getInitialCountry());

// 4. Persistence Logic
// Whenever the store value changes, save it back to localStorage
selectedCountry.subscribe(value => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, value);
  }
});

// Helper to get the full country object based on the current code
export const getCountryDetails = (code) => {
  return SUPPORTED_COUNTRIES.find(c => c.code === code) || SUPPORTED_COUNTRIES[0];
};